export default __webpack_public_path__ + "static/media/minutegraphic.e897bf0b.png";